import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { cancelSubscription, closeModal } from '../../redux/actions';
import { Modal } from '../../containers';
import { ModalHeading, ModalDescription, ModalButtonContainer } from '../../containers/Modal/styles';
import { Button } from '../index';
import { LoaderFontain } from '../../utils';

const CancelSubscriptionModal = ({ onConfirmClick, onCancelClick, isFetching }) => (
  <Modal empty noButton>
    {isFetching ? (
      <LoaderFontain height={199} />
    ) : (
      <Fragment>
        <ModalHeading>Are you sure?</ModalHeading>
        <ModalDescription>You are about to cancel your subscription. We hate to see you go! We wanted to remind you that there is a $79 reactivation fee, in case you change your mind.</ModalDescription>
        <ModalButtonContainer>
          <Button htmlType="button" theme="primary" onClick={onConfirmClick}>Confirm</Button>
          <Button htmlType="button" theme="secondary" onClick={onCancelClick}>Cancel</Button>
        </ModalButtonContainer>
      </Fragment>
    )}
  </Modal>
);

CancelSubscriptionModal.propTypes = {
  onConfirmClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  isFetching: PropTypes.bool,
};

const mapStateToProps = state => ({
  isFetching: state.user.isFetching,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onConfirmClick: cancelSubscription,
  onCancelClick: closeModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CancelSubscriptionModal);
